module.exports = __webpack_public_path__ + "media/insertion2cecum_1.be354a7e.wav";